module.exports = __webpack_public_path__ + "img/logo_h.0fef9fbe.svg";